import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary: ${props => props.theme.colors.primary};
    --secondary: ${props => props.theme.colors.secondary};
    --accent: ${props => props.theme.colors.accent};
    --background: ${props => props.theme.colors.background};
    --surface: ${props => props.theme.colors.surface};
    --text: ${props => props.theme.colors.text};
    --textSecondary: ${props => props.theme.colors.textSecondary};
  }

  * {
<<<<<<< HEAD
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  /* Optimizovane tranzicije - samo za specifične elemente */
  button, 
  a, 
  .nav-link,
  .theme-toggle,
  .card,
  .interactive-element {
    transition: 
      color 0.2s ease,
      background-color 0.2s ease,
      border-color 0.2s ease,
      transform 0.3s ease,
      opacity 0.3s ease,
      box-shadow 0.3s ease;
  }

  /* Brže tranzicije za temu */
  :root {
    transition: 
      --primary 0.2s ease,
      --secondary 0.2s ease,
      --accent 0.2s ease,
      --background 0.2s ease,
      --surface 0.2s ease,
      --text 0.2s ease,
      --text-secondary 0.2s ease;
=======
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
>>>>>>> e6b5101ea062b0e6c955ef3cfaa9eaec871b9c3b
  }

  body {
    background-color: var(--background);
    color: var(--text);
    min-height: 100vh;
    position: relative;
<<<<<<< HEAD
    transition: background-color 0.2s ease;
=======
>>>>>>> e6b5101ea062b0e6c955ef3cfaa9eaec871b9c3b
    
    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${props => props.theme.colors.background === '#FFFFFF' 
        ? 'linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(96, 165, 250, 0.05) 100%)'
        : 'radial-gradient(circle at 50% 50%, rgba(30, 64, 175, 0.05) 0%, transparent 100%)'};
      pointer-events: none;
      z-index: -1;
<<<<<<< HEAD
    }
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
  
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', sans-serif;
    font-weight: 700;
  }
  
  /* Smooth scrolling */
  html {
    scroll-behavior: smooth;
  }
  
  /* Animacije na skrol */
  .fade-in {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  }
  
  .fade-in.visible {
    opacity: 1;
    transform: translateY(0);
  }
  
  .slide-in-left {
    opacity: 0;
    transform: translateX(-50px);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  }
  
  .slide-in-left.visible {
    opacity: 1;
    transform: translateX(0);
  }
  
  .slide-in-right {
    opacity: 0;
    transform: translateX(50px);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  }
  
  .slide-in-right.visible {
    opacity: 1;
    transform: translateX(0);
  }
  
  .scale-in {
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
  }
  
  .scale-in.visible {
    opacity: 1;
    transform: scale(1);
  }
  
  /* Hover efekti */
  .hover-lift {
    transition: transform 0.2s ease;
  }
  
  .hover-lift:hover {
    transform: translateY(-5px);
  }
  
  .hover-glow {
    transition: box-shadow 0.2s ease, transform 0.2s ease;
  }
  
  .hover-glow:hover {
    box-shadow: 0 0 15px var(--primary);
    transform: translateY(-3px);
  }
  
  /* Animirani gradijent za pozadinu */
  @keyframes gradientAnimation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
=======
>>>>>>> e6b5101ea062b0e6c955ef3cfaa9eaec871b9c3b
    }
  }

  ::selection {
    background-color: var(--primary);
    color: white;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: var(--surface);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--primary);
    border-radius: 5px;
    
    &:hover {
      background: var(--secondary);
    }
  }

  section {
    position: relative;
    overflow: hidden;
    
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: ${props => props.theme.colors.background === '#FFFFFF'
        ? 'linear-gradient(135deg, rgba(37, 99, 235, 0.03) 0%, rgba(96, 165, 250, 0.03) 100%)'
        : 'none'};
      pointer-events: none;
      z-index: 0;
    }
  }

  footer {
    background-color: ${props => props.theme.colors.background === '#FFFFFF'
      ? 'var(--surface)'
      : props.theme.colors.surface};
    position: relative;
    z-index: 1;
  }
`;

export default GlobalStyles; 